var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0.5H9.95C4.4 0.5 0.05 4.95 0.05 10.5L0 80.5C0 86 4.4 90.5 9.95 90.5H80C85.5 90.5 90 86 90 80.5V10.5C90 4.95 85.5 0.5 80 0.5ZM80 60.5H64.35C62 60.5 60.1 62.2 59.45 64.5C57.7 70.85 51.85 75.5 45 75.5C38.15 75.5 32.3 70.85 30.55 64.5C29.9 62.2 28 60.5 25.65 60.5H10V15.5C10 12.75 12.25 10.5 15 10.5H75C77.75 10.5 80 12.75 80 15.5V60.5Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.145ce43135681d103b7cc01a3fd8f6d5.svg";
export { ForwardRef as ReactComponent };